var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "main" },
    [
      _c("ReportComment", { attrs: { mid: _vm.reporting } }),
      _vm._v(" "),
      _c("BreadCrumbs", { attrs: { pages: _vm.pages } }),
      _vm._v(" "),
      _c("section", { staticClass: "main__crypto-currency crypto-currency" }, [
        _c("div", { staticClass: "crypto-currency__container" }, [
          _c("div", { staticClass: "crypto-currency__box" }, [
            _c(
              "div",
              { staticClass: "crypto-currency__preview" },
              [
                _c("nuxt-img", {
                  attrs: {
                    src: _vm.$getImage(_vm.project.project_image),
                    alt:
                      _vm.project.title +
                      " " +
                      _vm.$t("common.at") +
                      " " +
                      _vm.$config.appName,
                    title: _vm.project.title,
                    placeholder: "",
                    loading: "lazy",
                  },
                  on: {
                    error: function ($event) {
                      $event.target.src =
                        _vm.$config.mediaUrl + "img/projects/default.webp"
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "crypto-currency__main" }, [
              _c("div", { staticClass: "crypto-currency__top top-content" }, [
                _c(
                  "div",
                  { staticClass: "crypto-currency__preview" },
                  [
                    _c("nuxt-img", {
                      attrs: {
                        src: _vm.$getImage(_vm.project.project_image),
                        alt:
                          _vm.project.title +
                          " " +
                          _vm.$t("common.at") +
                          " " +
                          _vm.$config.appName,
                        title: _vm.project.title,
                        placeholder: "",
                        loading: "lazy",
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src =
                            _vm.$config.mediaUrl + "img/projects/default.webp"
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "top-content__part crypto-currency-about" },
                  [
                    _c("div", { staticClass: "crypto-currency-about__head" }, [
                      _c(
                        "div",
                        { staticClass: "crypto-currency-about__title" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "crypto-currency-about__main-title",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.project.title) +
                                  "\n                    " +
                                  _vm._s(_vm.$t("project.price")) +
                                  "\n                  "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n                  (" +
                              _vm._s(_vm.project.token) +
                              ")\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "crypto-currency-about__price" },
                        [
                          _c(
                            "span",
                            {
                              attrs: {
                                "text-tooltip": "$" + _vm.generatePrice(),
                              },
                            },
                            [
                              _vm._v(
                                "\n                    $" +
                                  _vm._s(_vm.generateCutPrice()) +
                                  "\n                  "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "top-content-rate": true,
                                plus: _vm.project.volume_24h_procents > 0,
                                minus: _vm.project.volume_24h_procents < 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "top-content-rate__icon" },
                                [
                                  _vm.project.volume_24h_procents > 0
                                    ? _c("i", {
                                        staticClass: "bx bx-trending-up",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.project.volume_24h_procents < 0
                                    ? _c("i", {
                                        staticClass: "bx bx-trending-down",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "top-content-rate__percent" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$priceFormat(
                                          _vm.project.volume_24h_procents,
                                          2
                                        )
                                      ) +
                                      "%\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "top-content__part crypto-currency-tags" },
                  [
                    _c(
                      "div",
                      { staticClass: "crypto-currency-tags__box-tags" },
                      [
                        _c(
                          "div",
                          { staticClass: "crypto-currency-tags__list" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crypto-currency-tags__tag crypto-currency-tags__tag_marked",
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("project.rank")) +
                                    " #" +
                                    _vm._s(_vm.project.cmc_rank) +
                                    "\n                  "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.project.category !== null
                              ? _c(
                                  "div",
                                  { staticClass: "crypto-currency-tags__tag" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            `project.${_vm.project.category}`
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "crypto-currency-tags__tag" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("common.on")) +
                                    "\n                    " +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.project.watchlists,
                                        0
                                      )
                                    ) +
                                    "\n                    " +
                                    _vm._s(
                                      _vm.$numberToString(
                                        _vm.project.watchlists,
                                        [
                                          _vm.$t("project.watchlist"),
                                          _vm.$t("project.watchlists"),
                                          _vm.$t("project.many_watchlists"),
                                        ]
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "crypto-currency-tags__actions" },
                      [
                        _vm.user === null
                          ? _c(
                              "nuxt-link",
                              {
                                staticClass:
                                  "crypto-currency-tags__button crypto-currency-tags__button_big",
                                attrs: { to: _vm.localePath("/login") },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-icon",
                                  },
                                  [_c("i", { staticClass: "bx bxs-star" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("project.add_watchlist")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm.watchlistLoading
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "crypto-currency-tags__button crypto-currency-tags__button_big",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-text",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bx bx-loader-alt loading",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm.insideWatchlist
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "crypto-currency-tags__button crypto-currency-tags__button_big",
                                attrs: { type: "button" },
                                on: { click: _vm.toggleWatchlist },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-icon",
                                  },
                                  [_c("i", { staticClass: "bx bx-star" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("project.remove_watchlist")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "crypto-currency-tags__button crypto-currency-tags__button_big",
                                attrs: { type: "button" },
                                on: { click: _vm.toggleWatchlist },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-icon",
                                  },
                                  [_c("i", { staticClass: "bx bxs-star" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("project.add_watchlist")
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crypto-currency-tags__button disabled",
                            attrs: {
                              "text-tooltip": _vm.$t("project.share_off"),
                            },
                          },
                          [_c("i", { staticClass: "bx bxs-share-alt" })]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.project.type === "coin" || _vm.project.type === "token_sale"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "top-content__part crypto-currency-converter",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "crypto-currency-converter__title" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.project.token !== null
                                    ? _vm.project.token.toUpperCase()
                                    : _vm.project.title
                                ) +
                                "\n                " +
                                _vm._s(_vm.$t("common.to")) +
                                "\n                " +
                                _vm._s(_vm.currency.toUpperCase()) +
                                "\n                " +
                                _vm._s(_vm.$t("project.converter")) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crypto-currency-converter__header" },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "crypto-currency-converter__headline": true,
                                  "second-order":
                                    _vm.converter.type === "toCrypto",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-converter__icon",
                                  },
                                  [
                                    _c("nuxt-img", {
                                      attrs: {
                                        src: _vm.$getImage(
                                          _vm.project.project_image
                                        ),
                                        alt:
                                          _vm.project.title +
                                          " " +
                                          _vm.$t("common.at") +
                                          " " +
                                          _vm.$config.appName,
                                        title: _vm.project.title,
                                        placeholder: "",
                                        loading: "lazy",
                                      },
                                      on: {
                                        error: function ($event) {
                                          $event.target.src =
                                            _vm.$config.mediaUrl +
                                            "img/projects/default.webp"
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "crypto-currency-converter__label",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-converter__fullname",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.project.title) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.project.token !== null
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__fullname",
                                          },
                                          [
                                            _vm._v(
                                              "\n                      / " +
                                                _vm._s(_vm.project.token) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: {
                                  "crypto-currency-converter__headline crypto-currency-converter__select select": true,
                                  "is-active": _vm.dropdowns.currencyTop,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "select__header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleDropdown("currencyTop")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "select__current" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__icon",
                                          },
                                          [
                                            _vm.currency !== undefined
                                              ? _c("nuxt-img", {
                                                  attrs: {
                                                    src: `/design/currency/${_vm.currency.toLowerCase()}.png`,
                                                    alt: _vm.$t(
                                                      "project.fiat_alt"
                                                    ),
                                                    title:
                                                      _vm.$t(
                                                        "project.fiat_title"
                                                      ),
                                                    placeholder: "",
                                                    loading: "lazy",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__label",
                                          },
                                          [
                                            _vm.currency !== undefined
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "crypto-currency-converter__fullname",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            `currency.${_vm.currency.toLowerCase()}`
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                        /\n                        " +
                                                _vm._s(
                                                  _vm.currency.toUpperCase()
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(0),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "select__body" },
                                  _vm._l(_vm.currencies, function (curr, ind) {
                                    return _c(
                                      "div",
                                      {
                                        key: ind,
                                        staticClass: "select__item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeCurrency(curr.code)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__icon",
                                          },
                                          [
                                            _c("nuxt-img", {
                                              attrs: {
                                                src: `/design/currency/${curr.code.toLowerCase()}.png`,
                                                alt: _vm.$t("project.fiat_alt"),
                                                title:
                                                  _vm.$t("project.fiat_title"),
                                                placeholder: "",
                                                loading: "lazy",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__label",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "crypto-currency-converter__fullname",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        `currency.${curr.code.toLowerCase()}`
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                        /\n                        " +
                                                _vm._s(
                                                  curr.code.toUpperCase()
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crypto-currency-converter__body" },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "crypto-currency-converter__part": true,
                                  "second-order":
                                    _vm.converter.type === "toCrypto",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.converter.from,
                                      expression: "converter.from",
                                    },
                                  ],
                                  staticClass:
                                    "crypto-currency-converter__input",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.converter.from },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.converter,
                                          "from",
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        return _vm.convertCrypto("from")
                                      },
                                    ],
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crypto-currency-converter__body-icon",
                                on: { click: _vm.toggleConvertType },
                              },
                              [_c("i", { staticClass: "bx bx-transfer" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "crypto-currency-converter__part",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.converter.to,
                                      expression: "converter.to",
                                    },
                                  ],
                                  staticClass:
                                    "crypto-currency-converter__input",
                                  attrs: { type: "number" },
                                  domProps: { value: _vm.converter.to },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.converter,
                                          "to",
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        return _vm.convertCrypto("to")
                                      },
                                    ],
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "crypto-currency__middle middle-content" },
                [
                  _c("div", { staticClass: "middle-content__wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "middle-content__part crypto-currency-tags",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "crypto-currency-tags__box-tags" },
                          [
                            _c(
                              "div",
                              { staticClass: "crypto-currency-tags__list" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__tag crypto-currency-tags__tag_marked",
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("project.rank")) +
                                        " #" +
                                        _vm._s(_vm.project.cmc_rank) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.project.category !== null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__tag",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                `project.${_vm.project.category}`
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "crypto-currency-tags__tag" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("common.on")) +
                                        "\n                      " +
                                        _vm._s(
                                          _vm.$priceFormat(
                                            _vm.project.watchlists,
                                            0
                                          )
                                        ) +
                                        "\n                      " +
                                        _vm._s(
                                          _vm.$numberToString(
                                            _vm.project.watchlists,
                                            [
                                              _vm.$t("project.watchlist"),
                                              _vm.$t("project.watchlists"),
                                              _vm.$t("project.many_watchlists"),
                                            ]
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crypto-currency-tags__actions" },
                          [
                            _vm.user === null
                              ? _c(
                                  "nuxt-link",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button crypto-currency-tags__button_big",
                                    attrs: { to: _vm.localePath("/login") },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-icon",
                                      },
                                      [_c("i", { staticClass: "bx bxs-star" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("project.add_watchlist")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm.watchlistLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button crypto-currency-tags__button_big",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-text",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "bx bx-loader-alt loading",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm.insideWatchlist
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button crypto-currency-tags__button_big",
                                    attrs: { type: "button" },
                                    on: { click: _vm.toggleWatchlist },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-icon",
                                      },
                                      [_c("i", { staticClass: "bx bx-star" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("project.remove_watchlist")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "crypto-currency-tags__button crypto-currency-tags__button_big",
                                    attrs: { type: "button" },
                                    on: { click: _vm.toggleWatchlist },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-icon",
                                      },
                                      [_c("i", { staticClass: "bx bxs-star" })]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-tags__button-text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("project.add_watchlist")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crypto-currency-tags__button disabled",
                                attrs: {
                                  "text-tooltip": _vm.$t("project.share_off"),
                                },
                              },
                              [_c("i", { staticClass: "bx bxs-share-alt" })]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "middle-content__part middle-content-area market-cap",
                      },
                      [
                        _c("div", { staticClass: "middle-content__head" }, [
                          _c("div", { staticClass: "middle-content__title" }, [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("project.market_cap")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      ..._vm.tippyOptions,
                                      content:
                                        _vm.getContentById("marketcap_tooltip"),
                                    },
                                    expression:
                                      "{...tippyOptions, 'content': getContentById('marketcap_tooltip')}",
                                  },
                                ],
                                staticClass: "middle-content__title-icon",
                              },
                              [_c("i", { staticClass: "bx bxs-info-circle" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "middle-content__price" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.project.market_cap !== null
                                    ? "$" +
                                        _vm.$priceFormat(
                                          _vm.project.market_cap,
                                          0
                                        )
                                    : "--"
                                ) +
                                "\n                  "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "middle-content__stat stat-middle-content",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "stat-middle-content__row" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__label" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t("project.cap_to_volume")
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__value" },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.capToVolume) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "middle-content__part middle-content-area fully-cap",
                      },
                      [
                        _c("div", { staticClass: "middle-content__head" }, [
                          _c("div", { staticClass: "middle-content__title" }, [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("project.fdmc")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      ..._vm.tippyOptions,
                                      content:
                                        _vm.getContentById("fdmc_tooltip"),
                                    },
                                    expression:
                                      "{...tippyOptions, 'content': getContentById('fdmc_tooltip')}",
                                  },
                                ],
                                staticClass: "middle-content__title-icon",
                              },
                              [_c("i", { staticClass: "bx bxs-info-circle" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "middle-content__price" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.fdmc) +
                                "\n                  "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "middle-content__part middle-content-area volume",
                      },
                      [
                        _c("div", { staticClass: "middle-content__head" }, [
                          _c("div", { staticClass: "middle-content__title" }, [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("project.volume")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      ..._vm.tippyOptions,
                                      content:
                                        _vm.getContentById("volume_tooltip"),
                                    },
                                    expression:
                                      "{...tippyOptions, 'content': getContentById('volume_tooltip')}",
                                  },
                                ],
                                staticClass: "middle-content__title-icon",
                              },
                              [_c("i", { staticClass: "bx bxs-info-circle" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "middle-content__price" }, [
                            _vm._v(
                              "\n                    $" +
                                _vm._s(
                                  _vm.$priceFormat(_vm.project.volume_24h, 0)
                                ) +
                                "\n                  "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "middle-content-rate": true,
                                plus: _vm.project.volume_24h_procents > 0,
                                minus: _vm.project.volume_24h_procents < 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "middle-content-rate__icon" },
                                [
                                  _vm.project.volume_24h_procents > 0
                                    ? _c("i", {
                                        staticClass: "bx bx-trending-up",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.project.volume_24h_procents < 0
                                    ? _c("i", {
                                        staticClass: "bx bx-trending-down",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "middle-content-rate__percent" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$priceFormat(
                                          _vm.project.volume_24h_procents,
                                          2
                                        )
                                      ) +
                                      "%\n                    "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "middle-content__part middle-content-area supply",
                      },
                      [
                        _c("div", { staticClass: "middle-content__head" }, [
                          _c("div", { staticClass: "middle-content__title" }, [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.$t("project.circulation_supply")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      ..._vm.tippyOptions,
                                      content:
                                        _vm.getContentById("supply_tooltip"),
                                    },
                                    expression:
                                      "{...tippyOptions, 'content': getContentById('supply_tooltip')}",
                                  },
                                ],
                                staticClass: "middle-content__title-icon",
                              },
                              [_c("i", { staticClass: "bx bxs-info-circle" })]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "middle-content__price" }, [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.project.circulating_supply !== null
                                      ? _vm.$priceFormat(
                                          _vm.project.circulating_supply,
                                          0
                                        )
                                      : "--"
                                  ) +
                                  "\n                      " +
                                  _vm._s(
                                    _vm.project.token !== null
                                      ? _vm.project.token
                                      : ""
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "middle-content__stat stat-middle-content",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "stat-middle-content__row" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__label" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$t("project.max_supply")) +
                                          "\n                      "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              ..._vm.tippyOptions,
                                              content:
                                                _vm.getContentById(
                                                  "hardcap_tooltip"
                                                ),
                                            },
                                            expression:
                                              "{...tippyOptions, 'content': getContentById('hardcap_tooltip')}",
                                          },
                                        ],
                                        staticClass:
                                          "middle-content__title-icon",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bx bxs-info-circle",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__value" },
                                  [
                                    _vm._v(
                                      "\n                      $" +
                                        _vm._s(
                                          _vm.$priceFormat(
                                            _vm.project.hard_cap,
                                            0
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "stat-middle-content__row" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__label" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t("project.total_supply")
                                          ) +
                                          "\n                      "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              ..._vm.tippyOptions,
                                              content:
                                                _vm.getContentById(
                                                  "softcap_tooltip"
                                                ),
                                            },
                                            expression:
                                              "{...tippyOptions, 'content': getContentById('softcap_tooltip')}",
                                          },
                                        ],
                                        staticClass:
                                          "middle-content__title-icon",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bx bxs-info-circle",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "stat-middle-content__value" },
                                  [
                                    _vm._v(
                                      "\n                      $" +
                                        _vm._s(
                                          _vm.$priceFormat(
                                            _vm.project.soft_cap,
                                            0
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.project.type === "coin" ||
                    _vm.project.type === "token_sale"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "middle-content__part crypto-currency-converter",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "crypto-currency-converter__title",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.project.token !== null
                                        ? _vm.project.token.toUpperCase()
                                        : _vm.project.title
                                    ) +
                                    "\n                  " +
                                    _vm._s(_vm.$t("common.to")) +
                                    "\n                  " +
                                    _vm._s(_vm.currency.toUpperCase()) +
                                    "\n                  " +
                                    _vm._s(_vm.$t("project.converter")) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crypto-currency-converter__header",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "crypto-currency-converter__headline": true,
                                      "second-order":
                                        _vm.converter.type === "toCrypto",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "crypto-currency-converter__icon",
                                      },
                                      [
                                        _c("nuxt-img", {
                                          attrs: {
                                            src: _vm.$getImage(
                                              _vm.project.project_image
                                            ),
                                            alt:
                                              _vm.project.title +
                                              " " +
                                              _vm.$t("common.at") +
                                              " " +
                                              _vm.$config.appName,
                                            title: _vm.project.title,
                                            placeholder: "",
                                            loading: "lazy",
                                          },
                                          on: {
                                            error: function ($event) {
                                              $event.target.src =
                                                _vm.$config.mediaUrl +
                                                "img/projects/default.webp"
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "crypto-currency-converter__label",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "crypto-currency-converter__fullname",
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.project.title) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.project.token !== null
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "crypto-currency-converter__fullname",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        / " +
                                                    _vm._s(_vm.project.token) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "crypto-currency-converter__headline crypto-currency-converter__select select": true,
                                      "is-active": _vm.dropdowns.currencyBottom,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "select__header",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDropdown(
                                              "currencyBottom"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "select__current" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "crypto-currency-converter__icon",
                                              },
                                              [
                                                _vm.currency !== undefined
                                                  ? _c("nuxt-img", {
                                                      attrs: {
                                                        src: `/design/currency/${_vm.currency.toLowerCase()}.png`,
                                                        alt: _vm.$t(
                                                          "project.fiat_alt"
                                                        ),
                                                        title:
                                                          _vm.$t(
                                                            "project.fiat_title"
                                                          ),
                                                        placeholder: "",
                                                        loading: "lazy",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "crypto-currency-converter__label",
                                              },
                                              [
                                                _vm.currency !== undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "crypto-currency-converter__fullname",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                `currency.${_vm.currency.toLowerCase()}`
                                                              )
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                          /\n                          " +
                                                    _vm._s(
                                                      _vm.currency.toUpperCase()
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(1),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "select__body" },
                                      _vm._l(
                                        _vm.currencies,
                                        function (curr, ind) {
                                          return _c(
                                            "div",
                                            {
                                              key: ind,
                                              staticClass: "select__item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeCurrency(
                                                    curr.code
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "crypto-currency-converter__icon",
                                                },
                                                [
                                                  _c("nuxt-img", {
                                                    attrs: {
                                                      src: `/design/currency/${curr.code.toLowerCase()}.png`,
                                                      alt: _vm.$t(
                                                        "project.fiat_alt"
                                                      ),
                                                      title:
                                                        _vm.$t(
                                                          "project.fiat_title"
                                                        ),
                                                      placeholder: "",
                                                      loading: "lazy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "crypto-currency-converter__label",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "crypto-currency-converter__fullname",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              `currency.${curr.code.toLowerCase()}`
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                          /\n                          " +
                                                      _vm._s(
                                                        curr.code.toUpperCase()
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "crypto-currency-converter__body",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "crypto-currency-converter__part": true,
                                      "second-order":
                                        _vm.converter.type === "toCrypto",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.converter.from,
                                          expression: "converter.from",
                                        },
                                      ],
                                      staticClass:
                                        "crypto-currency-converter__input",
                                      attrs: { type: "number" },
                                      domProps: { value: _vm.converter.from },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.converter,
                                              "from",
                                              $event.target.value
                                            )
                                          },
                                          function ($event) {
                                            return _vm.convertCrypto("from")
                                          },
                                        ],
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-converter__body-icon",
                                    on: { click: _vm.toggleConvertType },
                                  },
                                  [_c("i", { staticClass: "bx bx-transfer" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crypto-currency-converter__part",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.converter.to,
                                          expression: "converter.to",
                                        },
                                      ],
                                      staticClass:
                                        "crypto-currency-converter__input",
                                      attrs: { type: "number" },
                                      domProps: { value: _vm.converter.to },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.converter,
                                              "to",
                                              $event.target.value
                                            )
                                          },
                                          function ($event) {
                                            return _vm.convertCrypto("to")
                                          },
                                        ],
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "crypto-currency__bottom bottom-content" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm.project.content,
                        expression: "project.content",
                      },
                    ],
                    staticClass: "crypto-currency__paragraph",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "links-list" }, [
                    _vm.project.site_url !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.site_url),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.website")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.whitepaper !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.whitepaper),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.whitepaper")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.source_code !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.source_code),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.source_code")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.address !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.address),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.blockchain_address")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.explorers !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.explorers),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.explorer_data")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.socials !== null
                      ? _c(
                          "a",
                          {
                            staticClass: "links-list__card",
                            attrs: {
                              href: _vm.$checkProtocol(_vm.project.socials),
                              rel: "nofollow noopener noreferrer",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("span", { staticClass: "links-list__text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("project.community_site")) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "main__currency-info currency-info" }, [
        _c("div", { staticClass: "currency-info__container" }, [
          _vm.project.type === "coin" || _vm.project.type === "token_sale"
            ? _c("div", { staticClass: "currency-info__part currency-graph" }, [
                _c("h3", { staticClass: "currency-graph__title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.project.token) +
                      "\n          " +
                      _vm._s(_vm.$t("common.to")) +
                      "\n          USD\n          " +
                      _vm._s(_vm.$t("project.chart")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-graph__content" }, [
                  _vm.avgValue !== 0
                    ? _c(
                        "div",
                        {
                          class: {
                            "currency-graph__graph": true,
                            "highcharts-dark": _vm.theme === "dark",
                          },
                        },
                        [
                          _c("highstock", {
                            ref: "stockChart",
                            attrs: {
                              options: _vm.stockOptions,
                              update: ["options.series"],
                            },
                            on: { chartLoaded: _vm.setChartLoaded },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          class: {
                            "currency-graph__graph not-found-area": true,
                            "highcharts-dark": _vm.theme === "dark",
                          },
                        },
                        [
                          _c("Empty"),
                          _vm._v(" "),
                          _c("div", { staticClass: "not-found-header" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("project.no_chart")) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { "loading-chart": true, loaded: _vm.chartLoaded },
                    },
                    [_c("i", { staticClass: "bx bx-loader-alt loading" })]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "currency-info__part currency-characteristic" },
            [
              _c("h3", { staticClass: "currency-characteristic__title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.project.token !== null
                        ? _vm.project.token
                        : _vm.project.title
                    ) +
                    "\n          " +
                    _vm._s(_vm.$t("project.fin_stats")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "currency-characteristic__list" }, [
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.price")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "currency-characteristic__rate": true,
                        plus: _vm.project.volume_24h_procents > 0,
                        minus: _vm.project.volume_24h_procents < 0,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "currency-characteristic__icon" },
                        [
                          _vm.project.volume_24h_procents > 0
                            ? _c("i", { staticClass: "bx bx-trending-up" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.project.volume_24h_procents < 0
                            ? _c("i", { staticClass: "bx bx-trending-down" })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "currency-characteristic__percent" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$priceFormat(
                                  _vm.project.volume_24h_procents,
                                  2
                                )
                              ) +
                              "%\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              $" +
                        _vm._s(
                          _vm.project.price > 1
                            ? _vm.$priceFormat(_vm.project.price, 2)
                            : _vm.project.price >= 0.0001
                            ? _vm.$priceFormat(_vm.project.price, 5)
                            : _vm.$formatCryptoAmount(_vm.project.price, 8)
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.trading_volume")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              $" +
                        _vm._s(_vm.$priceFormat(_vm.project.volume_24h, 0)) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.market_cap")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              $" +
                        _vm._s(_vm.$priceFormat(_vm.project.market_cap, 0)) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.circulation_supply")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$priceFormat(_vm.project.circulating_supply, 0)
                        ) +
                        "\n              " +
                        _vm._s(
                          _vm.project.token !== null
                            ? _vm.project.token.toUpperCase()
                            : ""
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.market_dominance")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.project.market_dominance !== null
                            ? _vm.$priceFormat(
                                _vm.project.market_dominance,
                                2
                              ) + "%"
                            : "--"
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.market_rank")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              #" +
                        _vm._s(_vm.project.cmc_rank) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currency-characteristic__el" }, [
                  _c("span", { staticClass: "currency-characteristic__name" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.platform")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-characteristic__value" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.project.platform !== null
                            ? _vm.project.platform
                            : _vm.$t("project.not_set")
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "currency-info__part live-chat" }, [
            _c("h3", { staticClass: "live-chat__title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("project.live_chat")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "live-chat__chat live-chat-box" }, [
              _c(
                "div",
                { staticClass: "live-chat-box__post-comment post-comment" },
                [
                  _c("div", { staticClass: "post-comment__header" }, [
                    _c(
                      "div",
                      { staticClass: "live-chat__user user-live-chat" },
                      [
                        _c(
                          "div",
                          { staticClass: "user-live-chat__avatar" },
                          [
                            _vm.user !== null
                              ? _c("nuxt-img", {
                                  attrs: {
                                    src: _vm.$getImage(
                                      _vm.user.avatar,
                                      "users"
                                    ),
                                    alt:
                                      _vm.user.name +
                                      " " +
                                      _vm.$t("common.at") +
                                      " " +
                                      _vm.$config.appName,
                                    title: _vm.user.name,
                                    loading: "lazy",
                                  },
                                  on: {
                                    error: function ($event) {
                                      $event.target.src =
                                        _vm.$config.mediaUrl +
                                        "img/users/default.webp"
                                    },
                                  },
                                })
                              : _c("nuxt-img", {
                                  attrs: {
                                    src: _vm.$getImage(null, "users"),
                                    alt:
                                      _vm.$t("common.login_to") +
                                      " " +
                                      _vm.$config.appName,
                                    title: _vm.$t("common.login_first"),
                                    placeholder: "",
                                    loading: "lazy",
                                  },
                                  on: {
                                    error: function ($event) {
                                      $event.target.src =
                                        _vm.$config.mediaUrl +
                                        "img/users/default.webp"
                                    },
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.user !== null
                          ? _c(
                              "div",
                              { staticClass: "user-live-chat__about" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "user-live-chat__name" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.user.name) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "user-live-chat__username" },
                                  [
                                    _vm._v(
                                      "\n                    @" +
                                        _vm._s(_vm.user.username) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "user-live-chat__about" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "user-live-chat__name" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.$t("common.login_first")) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "user-live-chat__username" },
                                  [_vm._v("@username")]
                                ),
                              ]
                            ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "post-comment__actions" }, [
                      _c(
                        "button",
                        {
                          class: {
                            "post-comment__button post-comment__button_green": true,
                            active: _vm.userMessage.type === "bullish",
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setCommentType("bullish")
                            },
                          },
                        },
                        [
                          _vm._m(8),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("project.bullish")) +
                                "\n                  "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: {
                            "post-comment__button post-comment__button_red": true,
                            active: _vm.userMessage.type === "bearish",
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setCommentType("bearish")
                            },
                          },
                        },
                        [
                          _vm._m(9),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("project.bearish")) +
                                "\n                  "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.userMessage.reply_to !== null && _vm.replyTo !== null
                    ? _c("span", { staticClass: "replying-to" }, [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("project.replying_to")) +
                              ":\n                " +
                              _vm._s(_vm.replyTo.name) +
                              " (@" +
                              _vm._s(_vm.replyTo.username) +
                              ")\n              "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "post-comment__area" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userMessage.message,
                          expression: "userMessage.message",
                        },
                      ],
                      staticClass: "post-comment__input",
                      attrs: { placeholder: _vm.$t("project.your_message") },
                      domProps: { value: _vm.userMessage.message },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.userMessage,
                            "message",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: {
                          "post-comment__button": true,
                          disabled: _vm.user === null || _vm.loadingMessage,
                        },
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("project.send_message"),
                        },
                        on: { click: _vm.sendChatMessage },
                      },
                      [
                        !_vm.loadingMessage
                          ? _c("i", { staticClass: "bx bx-paper-plane" })
                          : _c("i", {
                              staticClass: "bx bx-loader-alt loading",
                            }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.user === null
                    ? _c(
                        "div",
                        { staticClass: "login__overlay" },
                        [
                          _c(
                            "nuxt-link",
                            {
                              staticClass: "button filled-button",
                              attrs: { to: _vm.localePath("/login") },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.login_to_discuss")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.loading && _vm.messages.length > 0
                ? _c(
                    "div",
                    { ref: "chatArea", staticClass: "comments-list" },
                    _vm._l(_vm.messages, function (msg, ind) {
                      return _c(
                        "div",
                        {
                          key: ind,
                          class: {
                            "live-chat-box__comment post-comment": true,
                            replying: _vm.userMessage.reply_to === msg.mid,
                          },
                        },
                        [
                          _c("div", { staticClass: "post-comment__header" }, [
                            _c(
                              "div",
                              { staticClass: "live-chat__user user-live-chat" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "user-live-chat__avatar" },
                                  [
                                    _c("nuxt-img", {
                                      attrs: {
                                        src: _vm.$getImage(
                                          msg.author_image,
                                          "users"
                                        ),
                                        alt:
                                          msg.name +
                                          " " +
                                          _vm.$t("common.at") +
                                          " " +
                                          _vm.$config.appName,
                                        title: msg.name,
                                        placeholder: "",
                                        loading: "lazy",
                                      },
                                      on: {
                                        error: function ($event) {
                                          $event.target.src =
                                            _vm.$config.mediaUrl +
                                            "img/users/default.webp"
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-live-chat__about" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "user-live-chat__name" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(msg.name) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "user-live-chat__username",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      @" +
                                            _vm._s(msg.username) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "post-comment__remaining" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$realisticDate(msg.created_at)) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "post-comment__actions" },
                              [
                                msg.type === "bullish"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "post-comment__button post-comment__button_green",
                                      },
                                      [
                                        _vm._m(11, true),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("project.bullish")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    )
                                  : msg.type === "bearish"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "post-comment__button post-comment__button_red",
                                      },
                                      [
                                        _vm._m(12, true),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("project.bearish")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "post-comment__comment" }, [
                            msg.reply_username !== null
                              ? _c("div", { staticClass: "reply-to-label" }, [
                                  _c("i", { staticClass: "bx bx-reply" }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("project.replying_to")) +
                                      " @" +
                                      _vm._s(msg.reply_username) +
                                      ":\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {
                              directives: [
                                {
                                  name: "dompurify-html",
                                  rawName: "v-dompurify-html",
                                  value: msg.message,
                                  expression: "msg.message",
                                },
                              ],
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "post-comment__remaining" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$realisticDate(msg.created_at)) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-actions" }, [
                            _c("div", { staticClass: "user-actions__action" }, [
                              _vm.user === null
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-actions__button disabled",
                                    },
                                    [_vm._m(13, true)]
                                  )
                                : msg.like_date !== undefined &&
                                  msg.like_date !== null
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "user-actions__button",
                                      attrs: {
                                        type: "button",
                                        "aria-label": _vm.$t("project.dislike"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.unlikeMessage(msg.mid)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "user-actions__icon" },
                                        [
                                          _vm.chatActionsLoading.like !==
                                          msg.mid
                                            ? _c("i", {
                                                staticClass: "bx bxs-heart",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "bx bx-loader-alt loading",
                                              }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "user-actions__button",
                                      attrs: {
                                        type: "button",
                                        "aria-label": _vm.$t("project.like"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.likeMessage(msg.mid)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "user-actions__icon" },
                                        [
                                          _vm.chatActionsLoading.like !==
                                          msg.mid
                                            ? _c("i", {
                                                staticClass: "bx bx-heart",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "bx bx-loader-alt loading",
                                              }),
                                        ]
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "user-actions__count" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$getBigNumber(msg.likes)) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-actions__action" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "user-actions__button disabled",
                                  attrs: {
                                    type: "button",
                                    "aria-label": _vm.$t("project.report"),
                                    "text-tooltip": _vm.$t("project.report"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reportMid(msg.mid)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "user-actions__icon" },
                                    [
                                      _vm.chatActionsLoading.report !== msg.mid
                                        ? _c("i", {
                                            staticClass: "bx bxs-flag-alt",
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "bx bx-loader-alt loading",
                                          }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-actions__action" }, [
                              _vm.user === null
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-actions__button disabled",
                                      attrs: {
                                        "text-tooltip": _vm.$t("project.share"),
                                      },
                                    },
                                    [_vm._m(14, true)]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "user-actions__button",
                                      attrs: {
                                        type: "button",
                                        "aria-label": _vm.$t("project.reply"),
                                        "text-tooltip": _vm.$t("project.reply"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setReplyTo(
                                            msg.mid,
                                            msg.uid
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(15, true)]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-actions__action" }, [
                              _vm.user !== null && msg.uid === _vm.user.id
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "user-actions__button",
                                      attrs: {
                                        type: "button",
                                        "aria-label": _vm.$t("project.remove"),
                                        "text-tooltip":
                                          _vm.$t("project.remove"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteMyMessage(msg.mid)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "user-actions__icon" },
                                        [
                                          _vm.chatActionsLoading.delete !==
                                          msg.mid
                                            ? _c("i", {
                                                staticClass: "bx bxs-trash",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "bx bx-loader-alt loading",
                                              }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.loading
                ? _c(
                    "div",
                    { ref: "chatArea", staticClass: "comments-list" },
                    _vm._l(5, function (index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "live-chat-box__comment post-comment",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "post-comment__header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "live-chat__user user-live-chat",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "user-live-chat__avatar" },
                                    [
                                      _c("Skeleton", {
                                        attrs: {
                                          width: "28px",
                                          height: "28px",
                                          circle: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "user-live-chat__about" },
                                    [
                                      _c("Skeleton", {
                                        staticClass: "user-live-chat__name",
                                        attrs: {
                                          width: "73px",
                                          height: "15px",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("Skeleton", {
                                        staticClass: "user-live-chat__username",
                                        attrs: {
                                          width: "50px",
                                          height: "12px",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("Skeleton", {
                                staticClass: "post-comment__remaining",
                                attrs: { width: "60px", height: "12px" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "post-comment__actions" },
                                [
                                  _c("Skeleton", {
                                    staticClass: "post-comment__button",
                                    attrs: { width: "67px", height: "28px" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "post-comment__comment" },
                            [
                              _c("Skeleton", {
                                staticStyle: { "margin-bottom": ".5rem" },
                                attrs: { width: "200px", height: "14px" },
                              }),
                              _vm._v(" "),
                              _c("Skeleton", {
                                attrs: { width: "130px", height: "14px" },
                              }),
                              _vm._v(" "),
                              _c("Skeleton", {
                                staticClass: "post-comment__remaining",
                                attrs: { width: "60px", height: "12px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-actions" }, [
                            _c(
                              "div",
                              { staticClass: "user-actions__action" },
                              [
                                _vm._m(16, true),
                                _vm._v(" "),
                                _c("Skeleton", {
                                  staticClass: "user-actions__count",
                                  attrs: { width: "15px", height: "12px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(17, true),
                            _vm._v(" "),
                            _vm._m(18, true),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      ref: "chatArea",
                      staticClass: "comments-list not-found-area",
                    },
                    [
                      _c("Empty"),
                      _vm._v(" "),
                      _c("div", { staticClass: "not-found-header" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("project.no_comment_yet")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass:
            "main__watchlist watchlist watchlist_mod watchlist_currency shorten",
        },
        [
          _c("div", { staticClass: "watchlist__container" }, [
            _c("div", { staticClass: "watchlist__header watchlist-header" }, [
              _c("h2", { staticClass: "watchlist-header__title mr-4" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.project.title) +
                    "\n          " +
                    _vm._s(_vm.$t("project.markets")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "watchlist-categories" },
                _vm._l(_vm.categories, function (cat, ind) {
                  return _c(
                    "li",
                    {
                      key: ind,
                      class: {
                        "watchlist-categories__el": true,
                        "watchlist-categories__el_curent":
                          cat === _vm.pairsFilter.category ||
                          (cat === "all" && _vm.pairsFilter.category === null),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectPairCategory(cat)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "watchlist-categories__text" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t(`project.${cat}`)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "watchlist-showing" }, [
                _c(
                  "span",
                  {
                    staticClass: "watchlist-showing__title",
                    attrs: { "data-v-2a183b29": "" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("project.pairs_with")) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "watchlist-showing__select select": true,
                      "is-active": _vm.dropdowns.pair,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "select__header",
                        on: {
                          click: function ($event) {
                            return _vm.toggleDropdown("pair")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "select__current" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pairsFilter.pair !== null
                                  ? _vm.pairsFilter.pair
                                  : _vm.$t("project.any_coins")
                              ) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(19),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "select__body" },
                      _vm._l(_vm.filterPairs, function (fp) {
                        return _c(
                          "span",
                          {
                            key: fp,
                            staticClass: "select__item",
                            on: {
                              click: function ($event) {
                                return _vm.changeFilterPair(fp)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  fp !== "all"
                                    ? fp
                                    : _vm.$t("project.any_coins")
                                ) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.pairsInit || _vm.pairsTotal > 0
              ? _c("div", { staticClass: "watchlist-main" }, [
                  _c("div", { staticClass: "watchlist-main__wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "watchlist-main__header watchlist-legends one-field",
                      },
                      [
                        _vm._m(20),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "watchlist-legend watchlist-legends__title",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "watchlist-legends__name" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("project.name")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.pair")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "watchlist-legend sortable",
                            on: {
                              click: function ($event) {
                                return _vm.changeSort("price")
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "watchlist-legends__name" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("project.price")) +
                                    "\n                "
                                ),
                                _vm.pairsFilter.orderField.includes("price")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "watchlist-legends__icon",
                                      },
                                      [
                                        _vm.pairsFilter.orderField.toLowerCase() ===
                                        "price_desc"
                                          ? _c("i", {
                                              staticClass: "bx bxs-down-arrow",
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.pairsFilter.orderField.toLowerCase() ===
                                        "price_asc"
                                          ? _c("i", {
                                              staticClass: "bx bxs-up-arrow",
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.fee_type")) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        ..._vm.tippyOptions,
                                        content: _vm.getContentById("fee_type"),
                                      },
                                      expression:
                                        "{...tippyOptions, 'content': getContentById('fee_type')}",
                                    },
                                  ],
                                  staticClass: "tip",
                                },
                                [_c("i", { staticClass: "bx bxs-info-circle" })]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.currency_type")) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        ..._vm.tippyOptions,
                                        content:
                                          _vm.getContentById("currency_type"),
                                      },
                                      expression:
                                        "{...tippyOptions, 'content': getContentById('currency_type')}",
                                    },
                                  ],
                                  staticClass: "tip",
                                },
                                [_c("i", { staticClass: "bx bxs-info-circle" })]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "watchlist-legend sortable",
                            on: {
                              click: function ($event) {
                                return _vm.changeSort("volume")
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "watchlist-legends__name" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("project.volume")) +
                                    "\n                "
                                ),
                                _vm.pairsFilter.orderField.includes("volume")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "watchlist-legends__icon",
                                      },
                                      [
                                        _vm.pairsFilter.orderField.toLowerCase() ===
                                        "volume_desc"
                                          ? _c("i", {
                                              staticClass: "bx bxs-down-arrow",
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.pairsFilter.orderField.toLowerCase() ===
                                        "volume_asc"
                                          ? _c("i", {
                                              staticClass: "bx bxs-up-arrow",
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.volume")) +
                                  ", %\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.volume_base")) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        ..._vm.tippyOptions,
                                        content:
                                          _vm.getContentById("volume_base"),
                                      },
                                      expression:
                                        "{...tippyOptions, 'content': getContentById('volume_base')}",
                                    },
                                  ],
                                  staticClass: "tip",
                                },
                                [_c("i", { staticClass: "bx bxs-info-circle" })]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "watchlist-legend" }, [
                          _c(
                            "div",
                            { staticClass: "watchlist-legends__name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.updated")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    (!_vm.pairsLoading || _vm.pairsFilter.page > 1) &&
                    _vm.pairsTotal > 0
                      ? _c(
                          "div",
                          { staticClass: "watchlist-main__list" },
                          _vm._l(_vm.pairs, function (pair, ind) {
                            return _c(
                              "div",
                              { key: ind, staticClass: "watchlist-product" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "watchlist-product__wrapper one-field",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product__part_actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "watchlist-product__num",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(ind + 1) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-name",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "watchlist-product-name__box",
                                          },
                                          [
                                            pair.slug !== undefined &&
                                            pair.title !== null
                                              ? _c(
                                                  "nuxt-link",
                                                  {
                                                    staticClass:
                                                      "watchlist-product-name__icon",
                                                    attrs: {
                                                      to: _vm.$getProjectLink(
                                                        pair.type ||
                                                          pair.category,
                                                        pair.slug
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c("nuxt-img", {
                                                      attrs: {
                                                        src: _vm.$getImage(
                                                          pair.image,
                                                          "projects"
                                                        ),
                                                        alt:
                                                          pair.title +
                                                          " " +
                                                          _vm.$t("common.at") +
                                                          " " +
                                                          _vm.$config.appName,
                                                        title: pair.title,
                                                        quality: 80,
                                                        format: "webp",
                                                        loading: "lazy",
                                                      },
                                                      on: {
                                                        error: function (
                                                          $event
                                                        ) {
                                                          $event.target.src =
                                                            _vm.$config
                                                              .mediaUrl +
                                                            "img/projects/default.webp"
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "watchlist-product-name__icon",
                                                  },
                                                  [
                                                    _c("nuxt-img", {
                                                      attrs: {
                                                        src: _vm.$getImage(
                                                          pair.image,
                                                          "projects"
                                                        ),
                                                        alt:
                                                          pair.title +
                                                          " " +
                                                          _vm.$t("common.at") +
                                                          " " +
                                                          _vm.$config.appName,
                                                        title: pair.title,
                                                        quality: 80,
                                                        format: "webp",
                                                        loading: "lazy",
                                                      },
                                                      on: {
                                                        error: function (
                                                          $event
                                                        ) {
                                                          $event.target.src =
                                                            _vm.$config
                                                              .mediaUrl +
                                                            "img/projects/default.webp"
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                            _vm._v(" "),
                                            pair.slug !== undefined &&
                                            pair.title !== null
                                              ? _c(
                                                  "nuxt-link",
                                                  {
                                                    staticClass:
                                                      "watchlist-product-name__name",
                                                    attrs: {
                                                      to: _vm.$getProjectLink(
                                                        pair.type ||
                                                          pair.category,
                                                        pair.slug
                                                      ),
                                                      title: pair.title,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "watchlist-product-name__full-name",
                                                      },
                                                      [
                                                        pair.premium !== null
                                                          ? _c("i", {
                                                              staticClass:
                                                                "bx bxs-zap premium_icon",
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(pair.title) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "watchlist-product-name__name",
                                                    attrs: {
                                                      title: pair.curr_from,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "watchlist-product-name__full-name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              pair.curr_from
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single pairs",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              pair.curr_from +
                                                "/" +
                                                pair.curr_to
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product__price",
                                      },
                                      [
                                        pair.price !== null &&
                                        pair.price >= 0.0001
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "watchlist-product__text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    $" +
                                                    _vm._s(
                                                      pair.price > 1
                                                        ? _vm.$priceFormat(
                                                            pair.price,
                                                            2
                                                          )
                                                        : _vm.$formatCryptoAmount(
                                                            pair.price,
                                                            6
                                                          )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : pair.price !== null
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "watchlist-product__text",
                                                attrs: {
                                                  "text-tooltip":
                                                    "$" +
                                                    _vm.$formatCryptoAmount(
                                                      pair.price
                                                    ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    $" +
                                                    _vm._s(
                                                      _vm.generateCutPrice(
                                                        pair.price
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "watchlist-product__text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    $...\n                  "
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums fee-type",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(`project.${pair.fee}`)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums currency-type",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getPairShortcut(pair.pair)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums volume",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              pair.volume_24h !== null &&
                                                pair.volume_24h > 0
                                                ? "$" +
                                                    _vm.$priceFormat(
                                                      pair.volume_24h,
                                                      0
                                                    )
                                                : "--"
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums volume-percent",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              pair.volume_percent !== null
                                                ? pair.volume_percent > 0.01
                                                  ? _vm.$priceFormat(
                                                      pair.volume_percent,
                                                      2
                                                    ) + "%"
                                                  : "<0.01%"
                                                : "--"
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single volume-base",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$priceFormat(
                                                pair.volume_base,
                                                2
                                              )
                                            ) +
                                            "\n                  " +
                                            _vm._s(pair.curr_from) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single upd",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$realisticDate(
                                                pair.updated_at
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : (_vm.pairsLoading && _vm.pairsFilter.page === 1) ||
                        !_vm.pairsInit
                      ? _c(
                          "div",
                          { staticClass: "watchlist-main__list" },
                          _vm._l(10, function (ind) {
                            return _c(
                              "div",
                              { key: ind, staticClass: "watchlist-product" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "watchlist-product__wrapper one-field",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product__part_actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "watchlist-product__num",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(ind) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-name",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "watchlist-product-name__box",
                                          },
                                          [
                                            _c("Skeleton", {
                                              staticClass:
                                                "watchlist-product-name__icon",
                                              attrs: {
                                                width: "25px",
                                                height: "25px",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("Skeleton", {
                                              staticClass:
                                                "watchlist-product-name__name",
                                              attrs: {
                                                width: "65px",
                                                height: "16px",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single pairs",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "70px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product__price",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "75px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums depth-minus",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "80px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums depth-plus",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "80px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums volume",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "80px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single watchlist-product-nums volume-percent",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "40px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single volume-base",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "70px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "watchlist-product__part watchlist-product-single upd",
                                      },
                                      [
                                        _c("Skeleton", {
                                          attrs: {
                                            width: "90px",
                                            height: "16px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ])
              : _c("div", { staticClass: "watchlist-main" }, [
                  _c("div", { staticClass: "watchlist-main__wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "not-found-area" },
                      [
                        _c("Empty"),
                        _vm._v(" "),
                        _c("div", { staticClass: "not-found-header" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("project.no_pairs_yet")) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
            _vm._v(" "),
            _vm.pairsTotal >= _vm.pairsFilter.page * _vm.pairsFilter.step ||
            _vm.pairsLoading
              ? _c("div", { staticClass: "section-button" }, [
                  _c(
                    "button",
                    {
                      class: {
                        "section-button__button": true,
                        disabled: _vm.pairsLoading,
                      },
                      attrs: { type: "button", disabled: _vm.pairsLoading },
                      on: { click: _vm.loadMorePairs },
                    },
                    [
                      !_vm.pairsLoading
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("project.load_more_pairs")) +
                                "\n          "
                            ),
                          ])
                        : _c("span", [
                            _c("i", {
                              staticClass: "bx bx-loader-alt loading",
                            }),
                          ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.quotes.length > 0
        ? _c("section", { staticClass: "main__currency-info currency-info" }, [
            _c("div", { staticClass: "analytics__container" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.project.token !== null
                        ? _vm.project.token
                        : _vm.project.title
                    ) +
                    "\n        " +
                    _vm._s(_vm.$t("project.dynamic_analytics")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "monthly_area" }, [
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.project.token !== null
                          ? _vm.project.token
                          : _vm.project.title
                      ) +
                      "\n          " +
                      _vm._s(_vm.$t("project.monthly_returns")) +
                      " (USD)\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wide_table" },
                  [
                    _c(
                      "div",
                      { staticClass: "wide_table_col" },
                      [
                        _c("div", { staticClass: "wide_table_cell info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("project.year")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.quoteYears, function (year, yind) {
                          return _c(
                            "div",
                            { key: yind, staticClass: "wide_table_cell info" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(year) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "wide_table_cell info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("project.average")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "wide_table_cell info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("project.median")) +
                              "\n            "
                          ),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(12, function (month) {
                      return _c(
                        "div",
                        { key: month, staticClass: "wide_table_col" },
                        [
                          _c("div", { staticClass: "wide_table_cell info" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.months[month - 1]) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.quoteMonth(month), function (quote, mind) {
                            return _c(
                              "div",
                              {
                                key: mind,
                                class: {
                                  wide_table_cell: true,
                                  info: quote.percent === null,
                                  very_small:
                                    quote.percent !== null &&
                                    quote.percent <= -15,
                                  small:
                                    quote.percent !== null &&
                                    quote.percent <= -5 &&
                                    quote.percent > -15,
                                  little_small:
                                    quote.percent !== null &&
                                    quote.percent < 0 &&
                                    quote.percent > -5,
                                  little_high:
                                    quote.percent !== null &&
                                    quote.percent > 0 &&
                                    quote.percent < 5,
                                  high:
                                    quote.percent !== null &&
                                    quote.percent >= 5 &&
                                    quote.percent < 15,
                                  very_high:
                                    quote.percent !== null &&
                                    quote.percent >= 15,
                                },
                                attrs: {
                                  "text-tooltip":
                                    _vm.months[month - 1] + ", " + quote.year,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      quote.percent !== null
                                        ? (quote.percent > 0 ? "+" : "") +
                                            _vm.$priceFormat(quote.percent, 2) +
                                            "%"
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "wide_table_cell info" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.quoteAvg[month] !== undefined
                                    ? (_vm.quoteAvg[month] > 0 ? "+" : "") +
                                        _vm.$priceFormat(
                                          _vm.quoteAvg[month],
                                          2
                                        ) +
                                        "%"
                                    : "-"
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "wide_table_cell info" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.quoteMed[month] !== undefined
                                    ? (_vm.quoteMed[month] > 0 ? "+" : "") +
                                        _vm.$priceFormat(
                                          _vm.quoteMed[month],
                                          2
                                        ) +
                                        "%"
                                    : "-"
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "quote_stats_area" }, [
                _c("div", { staticClass: "monthly_area" }, [
                  _c("div", { staticClass: "h3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.project.token !== null
                            ? _vm.project.token
                            : _vm.project.title
                        ) +
                        "\n            " +
                        _vm._s(_vm.$t("project.quarterly_returns")) +
                        " (USD)\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wide_table quarters" },
                    [
                      _c(
                        "div",
                        { staticClass: "wide_table_col" },
                        [
                          _c("div", { staticClass: "wide_table_cell info" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("project.year")) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.quoteYears, function (year, yind) {
                            return _c(
                              "div",
                              {
                                key: yind,
                                staticClass: "wide_table_cell info",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(year) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(4, function (quarter) {
                        return _c(
                          "div",
                          { key: quarter, staticClass: "wide_table_col" },
                          [
                            _c("div", { staticClass: "wide_table_cell info" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("project.q") + quarter) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.getQuarter(quarter),
                              function (percent, qind) {
                                return _c(
                                  "div",
                                  {
                                    key: qind,
                                    class: {
                                      wide_table_cell: true,
                                      info: percent.percent === null,
                                      very_small:
                                        percent.percent !== null &&
                                        percent.percent <= -15,
                                      small:
                                        percent.percent !== null &&
                                        percent.percent <= -5 &&
                                        percent.percent > -15,
                                      little_small:
                                        percent.percent !== null &&
                                        percent.percent < 0 &&
                                        percent.percent > -5,
                                      little_high:
                                        percent.percent !== null &&
                                        percent.percent > 0 &&
                                        percent.percent < 5,
                                      high:
                                        percent.percent !== null &&
                                        percent.percent >= 5 &&
                                        percent.percent < 15,
                                      very_high:
                                        percent.percent !== null &&
                                        percent.percent >= 15,
                                    },
                                    attrs: {
                                      "text-tooltip":
                                        _vm.$t("project.q") +
                                        quarter +
                                        ", " +
                                        percent.year,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          percent.percent !== null
                                            ? (percent.percent > 0 ? "+" : "") +
                                                _vm.$priceFormat(
                                                  percent.percent,
                                                  2
                                                ) +
                                                "%"
                                            : "-"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.articlesLoading && _vm.articles.length > 0
        ? _c("section", { staticClass: "main__news news" }, [
            _c("div", { staticClass: "news__container" }, [
              _c("h2", { staticClass: "news__title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.project.title) +
                    "\n        " +
                    _vm._s(_vm.$t("project.news")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              !_vm.articlesLoading
                ? _c(
                    "div",
                    { staticClass: "news__list" },
                    _vm._l(_vm.articles, function (article, ind) {
                      return _c("ArticleCard", {
                        key: ind,
                        attrs: { article: article, "open-new-tab": true },
                      })
                    }),
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "news__list" },
                    _vm._l(2, function (index) {
                      return _c("ArticleCard", {
                        key: index,
                        attrs: { loading: true },
                      })
                    }),
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section-button" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "section-button__button",
                      attrs: { to: _vm.localePath("/articles") },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("news.read_more")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.projectsLoading && _vm.related.length > 0
        ? _c("section", { staticClass: "main__also-watch also-watch" }, [
            _c("div", { staticClass: "also-watch__container" }, [
              _c("h2", { staticClass: "also-watch__title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("project.also_watch")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "also-watch-box" }, [
                !_vm.projectsLoading
                  ? _c(
                      "div",
                      { staticClass: "also-watch__list" },
                      _vm._l(_vm.related, function (proj, ind) {
                        return _c(
                          "div",
                          { key: ind, staticClass: "also-watch-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "also-watch-card__head" },
                              [
                                _c(
                                  "nuxt-link",
                                  {
                                    staticClass: "also-watch-card__icon",
                                    attrs: {
                                      to: _vm.$getProjectLink(
                                        proj.type,
                                        proj.slug
                                      ),
                                    },
                                  },
                                  [
                                    _c("nuxt-img", {
                                      attrs: {
                                        src: _vm.$getImage(
                                          proj.project_image,
                                          "projects"
                                        ),
                                        alt:
                                          proj.title +
                                          _vm.$t("common.at") +
                                          " " +
                                          _vm.$config.appName,
                                        title: proj.title,
                                        quality: 80,
                                        format: "webp",
                                        loading: "lazy",
                                      },
                                      on: {
                                        error: function ($event) {
                                          $event.target.src =
                                            _vm.$config.mediaUrl +
                                            "img/projects/default.webp"
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "also-watch-card__stat" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "also-watch-card__currency",
                                      },
                                      [
                                        proj.premium !== null
                                          ? _c("i", {
                                              staticClass:
                                                "bx bxs-zap premium_icon",
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(proj.title) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "also-watch-card__price" },
                                      [
                                        _vm._v(
                                          "\n                  $" +
                                            _vm._s(
                                              _vm.$priceFormat(proj.price, 2)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "also-watch-card__rate": true,
                                          plus: proj.daily_percent > 0,
                                          minus: proj.daily_percent < 0,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "watchlist-product-rating-day__icon",
                                          },
                                          [
                                            proj.daily_percent > 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "bx bxs-up-arrow",
                                                })
                                              : proj.daily_percent < 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "bx bxs-down-arrow",
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "watchlist-product-rating-day__percent",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  proj.daily_percent !== null
                                                    ? _vm.$priceFormat(
                                                        proj.daily_percent,
                                                        2
                                                      ) + "%"
                                                    : "--"
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "also-watch__list" },
                      _vm._l(6, function (index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "also-watch-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "also-watch-card__head" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "also-watch-card__icon" },
                                  [
                                    _c("Skeleton", {
                                      attrs: {
                                        width: "35px",
                                        height: "35px",
                                        circle: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "also-watch-card__stat" },
                                  [
                                    _c("Skeleton", {
                                      staticClass: "also-watch-card__currency",
                                      attrs: { width: "60px", height: "18px" },
                                    }),
                                    _vm._v(" "),
                                    _c("Skeleton", {
                                      staticClass: "also-watch-card__price",
                                      attrs: { width: "80px", height: "24px" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "also-watch-card__rate" },
                                      [
                                        _c("Skeleton", {
                                          staticClass:
                                            "watchlist-product-rating-day__percent",
                                          attrs: {
                                            width: "40px",
                                            height: "15px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "also-watch-card__graph" },
                              [
                                _c("Skeleton", {
                                  attrs: { width: "140px", height: "50px" },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "tooltips" }, [
        _c(
          "div",
          { attrs: { id: "volume_tooltip" } },
          [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("main.volume_tooltip_p1")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "nuxt-link",
              {
                attrs: {
                  to: _vm.localePath("/glossary/trade-volume"),
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("main.read_more")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "marketcap_tooltip" } },
          [
            _c("p", [_vm._v(_vm._s(_vm.$t("main.marketcap_tooltip_p1")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("main.marketcap_tooltip_p2")))]),
            _vm._v(" "),
            _c(
              "nuxt-link",
              {
                attrs: {
                  to: _vm.localePath(
                    "/glossary/market-capitalization-market-cap-mcap"
                  ),
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("main.read_more")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "supply_tooltip" } },
          [
            _c("p", [_vm._v(_vm._s(_vm.$t("main.supply_tooltip_p1")))]),
            _vm._v(" "),
            _c(
              "nuxt-link",
              {
                attrs: {
                  to: _vm.localePath("/glossary/circulating-supply"),
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("main.read_more")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "cex_tooltip" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("main.cex_tooltip_p1")))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "dex_tooltip" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("main.dex_tooltip_p1")))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "hardcap_tooltip" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("main.hardcap_tooltip_p1")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("main.hardcap_tooltip_p2")))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "softcap_tooltip" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("main.softcap_tooltip_p1")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("main.hardcap_tooltip_p2")))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "fdmc_tooltip" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("main.fdmc_tooltip_p1")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("main.fdmc_tooltip_p2")))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "volume_base" } }, [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("project.volume_base_desc")) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "fee_type" } }, [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("project.fee_type_desc")) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "currency_type" } }, [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("project.currency_type_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("project.currency_type_cc")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("project.currency_type_cf")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("project.currency_type_fc")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("project.currency_type_ff")) +
                  "\n        "
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "select__icon" }, [
      _c("i", { staticClass: "bx bxs-down-arrow down-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "select__icon" }, [
      _c("i", { staticClass: "bx bxs-down-arrow down-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-globe" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-file-blank" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-code-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-network-chart" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-search-alt-2" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "links-list__icon" }, [
      _c("i", { staticClass: "bx bx-group" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "post-comment__button-icon" }, [
      _c("i", { staticClass: "bx bxs-up-arrow" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "post-comment__button-icon" }, [
      _c("i", { staticClass: "bx bxs-down-arrow" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "bx bx-reply" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "post-comment__button-icon" }, [
      _c("i", { staticClass: "bx bxs-up-arrow" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "post-comment__button-icon" }, [
      _c("i", { staticClass: "bx bxs-down-arrow" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__icon" }, [
      _c("i", { staticClass: "bx bxs-heart" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__icon" }, [
      _c("i", { staticClass: "bx bxs-share" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__icon" }, [
      _c("i", { staticClass: "bx bxs-share" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__button disabled" }, [
      _c("div", { staticClass: "user-actions__icon" }, [
        _c("i", { staticClass: "bx bxs-heart" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__action" }, [
      _c("div", { staticClass: "user-actions__button disabled" }, [
        _c("div", { staticClass: "user-actions__icon" }, [
          _c("i", { staticClass: "bx bxs-flag-alt" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-actions__action" }, [
      _c("div", { staticClass: "user-actions__button disabled" }, [
        _c("div", { staticClass: "user-actions__icon" }, [
          _c("i", { staticClass: "bx bxs-share" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "watchlist-showing__icon" }, [
      _c("i", { staticClass: "bx bxs-down-arrow" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "watchlist-legend watchlist-legends__order" },
      [
        _c("div", { staticClass: "watchlist-legends__name" }, [
          _vm._v("\n                #\n              "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }